import { render } from "datocms-structured-text-to-plain-text"
import React from "react"
import { StructuredText } from "react-datocms"

import { StatWrap, StatHead, StatBody } from "../styles/Statistics.styled"

const Statistic = ({ stat }) => {
  const { heading, body } = stat
  return (
    <StatWrap>
      <StatHead>{heading}</StatHead>
      {render(body)?.length > 0 && (
        <StatBody>
          <StructuredText
            data={body}
            renderInlineRecord={() => {}}
            renderInlineBlock={() => {}}
          />
        </StatBody>
      )}
    </StatWrap>
  )
}

export default Statistic
